<template>
  <div class="resumo">
    <div class="resumo__cabecalho">
      <div class="resumo__cabecalho-principal">
        <span class="resumo__icone-grande"><fa-icon :icon="tipo ? tipo.icone : 'clipboard-list'" /></span>
        <div class="resumo__cabecalho-texto">
          <div class="resumo__nome" :class="{ resumo__vazio: !item.descricao }">{{ item.descricao || "Regra sem descrição" }}</div>
          <div class="resumo__meta">
            <span :class="['resumo__status', item.ativo ? 'resumo__status--ativa' : 'resumo__status--inativa']">
              <fa-icon :icon="item.ativo ? 'check-circle' : 'pause-circle'" class="mr-1" />{{ situacao.label }}
            </span>
            <span><fa-icon icon="calendar-alt" class="mr-1" />{{ vigencia }}</span>
          </div>
        </div>
      </div>
      <div class="resumo__canais">
        <span v-for="canal in canais" :key="canal.campo" class="resumo__canal">
          <img :src="canal.imagem" alt="" class="resumo__canal-logo" />
          {{ canal.label }}
        </span>
        <span v-if="!canais.length" class="resumo__vazio">Nenhum canal selecionado</span>
      </div>
    </div>

    <div class="resumo__bloco">
      <div class="resumo__bloco-titulo">
        <span><fa-icon icon="sliders-h" class="mr-2" />{{ tipo ? tipo.label : "Regra" }}</span>
        <CButton size="sm" color="link" class="p-0" @click="$emit('editar', 1)">Alterar</CButton>
      </div>

      <template v-if="item.tipo === 'P'">
        <p class="resumo__texto">O pedido pode ter no máximo <strong>{{ percentual(item.perc_max_promocao) }}</strong> do valor em produtos de promoção.</p>
        <p class="resumo__texto resumo__texto--apoio">{{ quantidade(item.promocoesExcessao.length, "promoção desconsiderada", "promoções desconsideradas") }}</p>
      </template>

      <template v-else-if="item.tipo === 'M' || item.tipo === 'MP'">
        <p v-if="item.tipo === 'MP'" class="resumo__texto">
          O pedido pode ter no máximo <strong>{{ percentual(item.perc_max_mix) }}</strong> do valor em produtos do mix.
        </p>
        <p v-else class="resumo__texto">Todos os produtos do mix precisam estar no pedido nas quantidades definidas.</p>
        <ul v-if="item.produtos.length" class="resumo__lista">
          <li v-for="(produto, indice) in produtosVisiveis" :key="`${produto.produto_id}-${indice}`">
            <strong>{{ produto.produto_id }}</strong> · {{ produto.descricao }}
            <span v-if="item.tipo === 'M'" class="resumo__texto--apoio">({{ produto.qtd_min }} a {{ produto.qtd_max }})</span>
          </li>
          <li v-if="item.produtos.length > produtosVisiveis.length" class="resumo__texto--apoio">
            e mais {{ quantidade(item.produtos.length - produtosVisiveis.length, "produto", "produtos") }}
          </li>
        </ul>
        <p v-else class="resumo__vazio">Nenhum produto selecionado</p>
      </template>

      <template v-else-if="item.tipo === 'D'">
        <p class="resumo__texto">
          {{ Number(item.validar_todas_regras) ? "Todas as regras abaixo precisam ser válidas." : "Basta uma das regras abaixo ser válida." }}
        </p>
        <ul v-if="item.dimensoes.length" class="resumo__lista">
          <li v-for="(dimensao, indice) in item.dimensoes" :key="indice">
            <span v-if="indice" class="resumo__conector">{{ Number(item.validar_todas_regras) ? "e" : "ou" }}</span>
            Ao vender <strong>{{ segmento(dimensao.coluna, dimensao.dimensao_id) }}</strong>,
            <strong>{{ segmento(dimensao.coluna_vinculada, dimensao.dimensao_vinculada_id) }}</strong>
            deve representar de {{ percentual(dimensao.perc_min_vinculado) }} a {{ percentual(dimensao.perc_max_vinculado) }} do valor.
          </li>
        </ul>
        <p v-else class="resumo__vazio">Nenhuma regra de validação cadastrada</p>
      </template>

      <template v-else-if="item.tipo === 'QS'">
        <p class="resumo__texto">
          Executada em: <strong>{{ bancoQuery || "local não informado" }}</strong>
        </p>
        <pre v-if="item.querySQL && item.querySQL.query" class="resumo__codigo">{{ item.querySQL.query }}</pre>
        <p v-else class="resumo__vazio">Consulta não informada</p>
      </template>

      <template v-else-if="item.tipo === 'TF'">
        <p class="resumo__texto">
          {{ cobrancasTaxaFixa.length === 1 ? "Cobrança" : "Cobranças" }}:
          <strong v-if="cobrancasTaxaFixa.length">{{ cobrancasTaxaFixa.join(", ") }}</strong>
          <strong v-else>todas as cobranças com taxa fixa</strong>
        </p>
        <p class="resumo__texto">
          Validação da taxa: <strong>{{ modoContagemTaxaFixa }}</strong>
        </p>
        <p class="resumo__texto">
          Contar o pedido: <strong>{{ momentoContagemTaxaFixa }}</strong>
        </p>
        <p class="resumo__texto">{{ limiteTaxaFixa }}</p>
      </template>
    </div>

    <div class="resumo__bloco">
      <div class="resumo__bloco-titulo">
        <span><fa-icon icon="filter" class="mr-2" />Para quem a regra vale</span>
        <CButton size="sm" color="link" class="p-0" @click="$emit('editar', 2)">Alterar</CButton>
      </div>
      <div v-if="!linhasRestricoes.length" class="resumo__vazio">Sem restrições: a regra vale para todos os clientes.</div>
      <template v-else>
        <div class="resumo__texto--apoio mb-1">Clientes que atendem a todas:</div>
        <ul class="resumo__lista">
          <li v-for="(linha, indice) in linhasRestricoes" :key="linha.tipo">
            <span v-if="indice" class="resumo__conector">e</span>
            <strong>{{ linha.rotulo }}:</strong> {{ linha.valores }}
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import { formatPercentual } from "@/views/Cashback/helpers";
import { momentoContagemTaxaFixa, nomeCobranca, resumoLimiteTaxaFixa } from "../../../helpers/regraNegocio";
import { BANCOS_QUERY, MODOS_CONTAGEM_TAXA_FIXA, MODO_CONTAGEM_PADRAO, canaisDaRegra, rotuloRestricao, situacaoRegra, tipoRegra, vigenciaRegra } from "../../../constantes";

const PRODUTOS_VISIVEIS = 8;

export default {
  name: "ResumoRegraNegocio",

  props: {
    item: { type: Object, required: true },
    dimensoes: { type: Array, default: () => [] },
    promocoes: { type: Array, default: () => [] },
  },

  computed: {
    tipo() {
      return tipoRegra(this.item.tipo);
    },

    situacao() {
      return situacaoRegra(this.item);
    },

    vigencia() {
      return vigenciaRegra(this.item);
    },

    canais() {
      return canaisDaRegra(this.item);
    },

    produtosVisiveis() {
      return this.item.produtos.slice(0, PRODUTOS_VISIVEIS);
    },

    bancoQuery() {
      return this.item.querySQL ? BANCOS_QUERY[this.item.querySQL.banco] : null;
    },

    cobrancasTaxaFixa() {
      return ((this.item.taxaFixa && this.item.taxaFixa.cobrancas) || []).map((cobranca) => {
        const nome = nomeCobranca(cobranca);

        return nome !== String(cobranca.id) ? `${cobranca.id} - ${nome}` : nome;
      });
    },

    modoContagemTaxaFixa() {
      const modo = (this.item.taxaFixa && this.item.taxaFixa.modo_contagem) || MODO_CONTAGEM_PADRAO;

      return MODOS_CONTAGEM_TAXA_FIXA[modo] || modo;
    },

    momentoContagemTaxaFixa() {
      return momentoContagemTaxaFixa(this.item.taxaFixa);
    },

    limiteTaxaFixa() {
      return resumoLimiteTaxaFixa(this.item.taxaFixa) || "Limite por cliente não informado.";
    },

    linhasRestricoes() {
      const linhas = [];

      this.item.restricoes.forEach((restricao) => {
        let linha = linhas.find((existente) => existente.tipo === restricao.tipo);

        if (!linha) {
          linha = { tipo: restricao.tipo, rotulo: rotuloRestricao(restricao.tipo), lista: [] };
          linhas.push(linha);
        }

        linha.lista.push(restricao.chave);
      });

      return linhas.map((linha) => ({ ...linha, valores: this.juntarComOu(linha.lista) }));
    },
  },

  methods: {
    percentual(valor) {
      return formatPercentual(valor);
    },

    quantidade(total, singular, plural) {
      return `${total} ${total === 1 ? singular : plural}`;
    },

    juntarComOu(valores) {
      if (valores.length < 2) return valores.join("");

      return `${valores.slice(0, -1).join(", ")} ou ${valores[valores.length - 1]}`;
    },

    segmento(coluna, id) {
      const dimensao = this.dimensoes.find((item) => +item.coluna === +coluna);

      if (!dimensao) return id ? `segmento ${id}` : "segmento não informado";

      const opcao = (dimensao.dimensoes || []).find((item) => `${item.id}` === `${id}`);

      return `${dimensao.label}: ${opcao ? opcao.desc : id || "não informado"}`;
    },
  },
};
</script>

<style scoped src="@/components/regras/regra-resumo.css"></style>

<style scoped>
.resumo__nome {
  word-break: break-word;
}

.resumo__bloco-titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.resumo__texto {
  margin-bottom: 6px;
  font-size: 13px;
  color: #344054;
}

.resumo__texto--apoio {
  font-size: 12px;
  color: #667085;
}

.resumo__lista {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 13px;
  color: #344054;
  line-height: 1.7;
  word-break: break-word;
}

.resumo__codigo {
  max-height: 220px;
  margin: 0;
  padding: 10px 12px;
  overflow: auto;
  border-radius: 8px;
  background-color: #f9fafb;
  border: 1px solid #eaecf0;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
